import { useCallback } from 'react';
import { gql } from '@apollo/client';
import { graphql } from '@xolv-mybrightlink/common';

export const useDeleteMessage = (
  channelGuid: string,
  messageGuid: string,
): (() => Promise<void>) => {
  return useCallback(async () => {
    const mutation = gql`
      mutation deleteChatMessage($channelGuid: String!, $messageGuid: String!) {
        deleteChatMessage(channelGuid: $channelGuid, messageGuid: $messageGuid)
      }
    `;
    await graphql.mutate({ mutation, variables: { channelGuid, messageGuid } });
  }, [channelGuid, messageGuid]);
};
